export default "__VITE_ASSET__DWB7wpBi__"